import { StrokeType } from '@kildenshared/types/draw/stroke.type';

export const StrokeWidthsConst: StrokeType[] = [
  { label: '1 px', value: 1 },
  { label: '2 px', value: 2 },
  { label: '3 px', value: 3 },
  { label: '4 px', value: 4 },
  { label: '5 px', value: 5 },
];
